<template>
  <Forms class="Forms-Imobiliaria" ref="frmPermission"
            :title="title"
            :showHelp="true"
            :showClearButtonIcon="true"
            :ShowFooterImbo="true"
            :showSearchIcon="true"
            :showSearchButtonIcon="true"
            v-on:Clear="Clear"
            v-on:Search="Search"
            v-on:Load ="onLoad"
          >
           <div>
                    <label  class="labelseach mt-3" for="txtInsured">Imobiliária</label>
                    <autocomplete-z ref="ImobliariaTypeahead"
                          placeholder="Digite uma imobiliária"
                          iconClass="fas fa-sign"
                          :serializer="(Imobiliaria) => Imobiliaria.nome"
                          :debounceLength="3"
                          :formField="SearchItems.imobiliariaObj"
                          v-on:search="onSearchImobliaria"
                          v-on:changeCode="onSearchImobliaria"
                          :ShowCode="false"
                           />

                    <label  class="labelseach mt-3" for="txtInsured">Cidade</label>
                    <autocomplete-z ref="CidadeTypeahead"
                          placeholder="Digite uma cidade"
                          iconClass="fas fa-city"
                          :serializer="(cidade) => cidade.nome"
                          :debounceLength="3"
                          :formField="SearchItems.cidadeObj"
                          v-on:search="onSearchCidade"
                          v-on:changeCode="onSearchCidade"
                          :ShowCode="false"
                           />

              <label class="labelseach mt-3">UF</label>
              <select v-model ="SearchItems.estadoId" class="form-control" id="exampleFormControlSelect2">
                    <option disabled selected :value="''">Selecione o UF</option>
                    <option v-for="data in state" v-bind:key="data.id" :value="data.id">{{data.sigla == null ? '' : data.sigla}}</option>
              </select>

              </div>

             <label class="labelseach mt-3">Status</label>
              <select
              name="statusVistoria"
              class="form-control"
              v-model="SearchItems.situacao"
              id="exampleFormControlSelect2"
              >
                <option disabled selected :value="''">Selecione o status</option>
                <option v-for="status in situacaoCredenciada" :key="status.value" :value="status.value">{{status.text}}</option>
              </select>

              <label class="labelseach mt-3" for="txtInsured">Data de Cadastro</label>

              <div>
                <label class="labelseach margin-botao" > Desde </label>
              </div>

              <div class="d-flex align-items-end">
              <b-form-datepicker
              v-model ="SearchItems.DataCadastroInicio"
                placeholder="__/__/____"
                locale="pt-BR"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>
              </div>

              <div>
                <label class="labelseach margin-botao"> Até </label>
              </div>

              <div class="d-flex align-items-end">
                <b-form-datepicker
                v-model ="SearchItems.DataCadastroFim"
                placeholder="__/__/____"
                locale="pt-BR"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                ></b-form-datepicker>
              </div>
        </Forms>
</template>

<script>
import Searchaccredited from './searchaccredited.js'
export default Searchaccredited
</script>

<style scoped>

.Forms-Imobiliaria{
  width: 100%;
}

.margin-botao{
  padding: 0.5rem 0 0.5rem 0;
}

#form-cidade{
  width: 50%;
}

#form-uf{
  width: 40%;
  margin-left: 10%;
}
.labelseach{
  font-weight: 700;
  color: #666;
  font-size: 14px;
  margin-bottom: 5px;
  padding-bottom: 0;
  font-family: Segoe UI;
}

 @media screen and (max-width: 1600px) {
 .Forms-Imobiliaria{
  width: 100%;
 }
 .margin-botao{
  margin-bottom: 5%;
}
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/accredited/components/searchaccredited/searchaccredited.vue